import React, {Component} from 'react';
import underLineIcon from './underLine.png';
import {toolWidth} from "../../twoLinesEditorToolsSpace";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

class UnderLineTool extends Component {

    constructor(props) {
        super(props);
        this.state = {
            btnChecked:false
        }
    }

    /**
     * 监听内容变化
     */
    listenContentChange(){
        let underline = this.props.editor.queryCommandState("underline");
        this.setState({btnChecked: underline});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let underline = this.props.editor.queryCommandState("underline");
        this.setState({btnChecked: underline});
    }

    render() {
        let style = {};
        if(this.state.btnChecked && this.state.btnChecked !== -1){ //切换到源码的时候为-1
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'underline' );
                this.setState({btnChecked:true});
            }}>
                <img className={"editor-underline-tool-btn"} style={style} width={toolWidth} src={underLineIcon}/>
                <style>{`
                    .editor-underline-tool-btn{
                        border: 1px solid #f2f6fc
                    }
                    .editor-underline-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-underline-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </span>
        );
    }
}

export default UnderLineTool;